export default "__VITE_ASSET__Cde$E9Hu__"